// extracted by mini-css-extract-plugin
export default {"content":"Product_dev2_content__xhpmV","ref":"Product_dev2_ref__O0rlF"};